import React from 'react'
import { FaTruck, FaEuroSign, FaConciergeBell, FaHeadset, FaRunning } from 'react-icons/fa'

export default function StepsSection() {
  const steps = [
    {
      icon: <FaTruck className="text-[#0066CC] text-3xl mb-4" />,
      title: 'Abschleppservice',
      subtitle: 'Kostenlose Abholung',
      description: 'Vereinbaren Sie eine Abholung überall in Ibbenbüren – keine Abschleppgebühren.'
    },
    {
      icon: <FaEuroSign className="text-[#0066CC] text-3xl mb-4" />,
      title: 'Beste Preise',
      subtitle: 'Sofortige Zahlung',
      description: 'Erhalten Sie Ihr Geld noch am selben Tag, an dem Ihr Auto abgeholt wird.'
    },
    {
      icon: <FaRunning className="text-[#0066CC] text-3xl mb-4" />,
      title: 'Bequemlichkeit',
      subtitle: 'Bequemlichkeit',
      description: 'Alles wird ganz bequem und transparent online oder telefonisch abgewickelt.'
    },
    {
      icon: <FaHeadset className="text-[#0066CC] text-3xl mb-4" />,
      title: 'Kundenservice',
      subtitle: 'Kundenservice',
      description: 'Unser Team sorgt stets für eine reibungslose und transparente Abwicklung.'
    }
  ]

  return (
    <section className="bg-white py-12 md:py-16 lg:py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Autoverwertung Ibbenbüren in 4 Schritten
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
          {steps.map((step, index) => (
            <div key={index} className="text-center p-6 bg-gray-50 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="flex justify-center">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
              <h3 className="text-lg font-semibold text-[#0066CC] mb-3">{step.subtitle}</h3>
              <p className="text-gray-700 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
              className="bg-[#0066CC] hover:bg-[#004BA6] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg focus:outline-none"
              onClick={() => {
                const form = document.getElementById('contact-form');
                if (form) {
                  form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
              onMouseEnter={e => e.currentTarget.classList.add('animate-bounce')}
              onMouseLeave={e => e.currentTarget.classList.remove('animate-bounce')}
            > Autobewertung
          </button>
        </div>
      </div>
    </section>
  )
}